import {
  Dom, gsap, Draggable, ScrollToPlugin
} from '@univers-agency/jupiter'

import { MotionPathPlugin } from 'gsap/MotionPathPlugin'


gsap.registerPlugin(Draggable)
gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(MotionPathPlugin)

const PLACES = 4
const PART = 1.0 / PLACES

export default class Toolbar {
  constructor (parade) {
    this.$bgsound = Dom.find('#bgsounds')
    this.playingSound = true
    this.parade = parade
    this.$el = Dom.find('#toolbar')
    this.$elIndicatorPlace = Dom.find('.indicator__place')
    this.$circle = Dom.find('.indicator-object__circle')
    this.$place = Dom.find('[data-place]')
    this.$mainLayer = Dom.find('.layer-main')
    this.$indicatorLine = Dom.find('.indicator-object__line')
    this.indicatorActive = false

    gsap.set(this.$el, { yPercent: 100 })

    const soundButtons = Dom.all('.sound__switch__button button')
    this.$btnSoundOn = Dom.find('[data-sound="on"]')
    this.$btnSoundOff = Dom.find('[data-sound="off"]')
    Array.from(soundButtons).forEach(sb => {
      sb.addEventListener('click', this.toggleSound.bind(this))
    })
  }

  initializeIndicator () {
    this.calcIndicatorWidth()

    const that = this
    Draggable.create(this.$circle, {
      type: 'x',
      bounds: this.$indicatorLine,
      onMove () {
        that.indicatorActive = true
        if (that.parade.playing) {
          that.parade.pause()
        }
        const progression = gsap.utils.clamp(0, 1, this.x / this.maxX)
        that.parade.scrollTween.progress(progression)
        setTimeout(() => {
          that.indicatorActive = false
        }, 500)
      }
    })
  }

  calcIndicatorWidth () {
    this.indicatorWidth = this.$indicatorLine.getBoundingClientRect().width - this.$circle.getBoundingClientRect().width
  }

  toggleSound () {
    this.playingSound = !this.playingSound
    if (this.playingSound) {
      this.playSound()
      this.parade.$video.removeAttribute('muted')
    } else {
      this.stopSound()
      this.parade.$video.setAttribute('muted', '')
    }
    Dom.toggleClass(this.$btnSoundOn, 'active')
    Dom.toggleClass(this.$btnSoundOff, 'active')
  }

  playSound () {
    this.$bgsound.volume = 0.7
    this.$bgsound.addEventListener('timeupdate', function () {
      const buffer = 0.44
      if (this.currentTime > this.duration - buffer) {
        this.currentTime = 0
        this.play()
      }
    })
    this.$bgsound.play()
  }

  stopSound () {
    this.$bgsound.pause()
  }

  show () {
    this.initializeIndicator()
    gsap.to(this.$el, {
      duration: 1, delay: 0, yPercent: 0, ease: 'power2.inOut'
    })

    this.setInitialPlace()

    gsap.to(this.$elIndicatorPlace, {
      autoAlpha: 1,
      duration: 0.25,
      scale: 1,
      delay: 1.75
    })
  }

  setInitialPlace () {
    const placeRect = this.$elIndicatorPlace.getBoundingClientRect()
    const placeCenter = placeRect.width / 2

    const $circle = Dom.find('#indicator__circle')
    const circleRect = $circle.getBoundingClientRect()
    const circleCenter = circleRect.width / 2

    const left = placeCenter * -1 + circleCenter
    gsap.set(this.$elIndicatorPlace, { left })
  }

  movePlace (x) {
    const p = this.parade.scrollPositionPercent
    if (p >= 0 && p <= PART && this.$place.innerHTML !== 'Grønland') {
      this.setPlace('Grønland')
    }
    if (p > PART && p <= PART * 2 && this.$place.innerHTML !== 'Stortorvet') {
      this.setPlace('Stortorvet')
    }
    if (p > PART * 2 && p <= PART * 3 && this.$place.innerHTML !== 'Stortinget') {
      this.setPlace('Stortinget')
    }
    // if (p > PART * 3 && p <= PART * 4 && this.$place.innerHTML !== 'Kristiansand') {
    //   this.setPlace('Kristiansand')
    // }
    // if (p > PART * 4 && p <= PART * 5 && this.$place.innerHTML !== 'Trondheim') {
    //   this.setPlace('Trondheim')
    // }
    if (p > PART * 3 && this.$place.innerHTML !== 'Spikersuppa') {
      this.setPlace('Spikersuppa')
    }

    gsap.to(this.$elIndicatorPlace, { x })
  }

  setPlace (name) {
    this.$place.innerHTML = name
    this.setInitialPlace()
  }

  moveIndicator () {
    const x = this.indicatorWidth * this.parade.scrollPositionPercent

    if (!this.indicatorActive) {
      gsap.to(this.$circle, { x })
    }

    this.movePlace(x)
  }
}
